import { render, staticRenderFns } from "./outstandingDebtors.vue?vue&type=template&id=157aa80a&scoped=true&"
import script from "./outstandingDebtors.vue?vue&type=script&lang=js&"
export * from "./outstandingDebtors.vue?vue&type=script&lang=js&"
import style0 from "./outstandingDebtors.vue?vue&type=style&index=0&id=157aa80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157aa80a",
  null
  
)

export default component.exports